<template>
    <div class='main'>
        <div class='plugins-tips'>
            <el-row>
                <el-col :span='20'>
                    <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                        <el-form-item label='类型'>
                            <el-select size='mini' clearable v-model='queryParams.type' filterable
                                       placeholder='请选择类型'>
                                <el-option
                                    v-for='item in giftCodeTypeOptions'
                                    :key='item.value'
                                    :label='item.label'
                                    :value='item.value'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='渠道'>
                            <el-input
                                v-model='queryParams.channel'
                                placeholder='请输入渠道'
                                clearable
                                size='mini'
                                style='width: 180px'
                            />
                        </el-form-item>
                        <el-form-item label='礼包码'>
                            <el-input
                                v-model='queryParams.code'
                                placeholder='请输入礼包码'
                                clearable
                                size='mini'
                                style='width: 180px'
                            />
                        </el-form-item>
                        
                        <el-form-item label='兑换类型'>
                            <el-select clearable size='mini' v-model='queryParams.sendType' filterable
                                       placeholder='请选择事件类型'>
                                <el-option
                                    v-for='item in giftContentSendTypeOptions'
                                    :key='item.value'
                                    :label='item.label'
                                    :value='item.value'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='礼包状态'>
                            <el-select clearable size='mini' v-model='queryParams.status' filterable
                                       placeholder='请选择事件类型'>
                                <el-option
                                    v-for='item in giftStatusOptions'
                                    :key='item.value'
                                    :label='item.label'
                                    :value='item.value'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='礼包创建批次号'>
                            <el-input
                                v-model='queryParams.categoryTag'
                                placeholder='请输入礼包创建批次号'
                                clearable
                                size='mini'
                                style='width: 180px'
                            />
                        </el-form-item>
                        <el-form-item style='margin-bottom: 0'>
                            <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                            </el-button>
                            <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span='4'>
                    <el-row :gutter='5'>
                        <el-col :span='12'>
                            <el-button
                                type='primary'
                                plain
                                icon='el-icon-plus'
                                size='mini'
                                @click='handleAdd'
                            >新增礼包码
                            </el-button>
                        </el-col>
                        <el-col v-if='groupName' :span='12'>
                            <el-button
                                type='danger'
                                plain
                                icon='el-icon-delete'
                                size='mini'
                                @click='handleDeleteGroup'
                            >删除组
                            </el-button>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        
        <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='giftCodeList'
                  @sort-change='handleSortChange'>
            <el-table-column width='200' label='码' fixed align='center' prop='code' />
            <el-table-column width='150' label='礼包名' align='center' prop='name' />
            <el-table-column width='150' label='渠道' align='center' prop='channel' :show-overflow-tooltip='true' />
            <el-table-column width='100' label='状态' align='center' prop='status'>
                <template slot-scope='scope'>
                    <el-switch size='mini' @change='handleUpdateGiftCode(scope.row)' v-model='scope.row.status' />
                </template>
            </el-table-column>
            <el-table-column width='100' label='类型' align='center' prop='type'>
                <template slot-scope='scope'>
                    <el-tag :type='scope.row.type === "UNIQUE" ? "success" : "warning"'>
                        {{ scope.row.type === 'UNIQUE' ? '唯一码' : '通兑码' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column width='250' label='剩余/成功/失败' align='center' prop='balance'>
                <template slot-scope='scope'>
                    <span style='color: #409EFF'>{{ scope.row.number }}</span>&nbsp;/&nbsp;<span style='color: #67C23A'>{{ scope.row.redemptionSuccessNumber }}</span>&nbsp;/&nbsp;<span
                    style='color: #F56C6C'>{{ scope.row.redemptionFailNumber }}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label='内容' align='center' prop='content'>
                <template slot-scope='scope'>
                    <el-button type='text' @click='handleViewGiftContent(scope.row)'>查看</el-button>
                </template>
            </el-table-column>
            <el-table-column width='200' label='开始时间' align='center' prop='startTime' />
            <el-table-column width='200' label='结束时间' align='center' prop='endTime' />
            <el-table-column label='创建者' align='center'>
                <template slot-scope='scope'>
                    <span>{{ computeCreateUserAccount(scope.row, scope.id) }}</span>
                </template>
            </el-table-column>
            <el-table-column label='更新者' align='center'>
                <template slot-scope='scope'>
                    <span>{{ computeUpdateUserAccount(scope.row, scope.id) }}</span>
                </template>
            </el-table-column>
            <el-table-column width='200' label='礼包码创建批次号' align='center' prop='categoryTag' />
            <el-table-column width='200' sortable='custom' label='创建时间' align='center' prop='createTime' />
            <el-table-column width='200' sortable='custom' label='最后更新时间' align='center' prop='updateTime' />
            <el-table-column
                label='操作'
                align='center'
                width='300'
                fixed='right'
                class-name='small-padding fixed-width'
            >
                <template slot-scope='scope'>
                    <el-button
                        size='mini'
                        type='text'
                        icon='el-icon-edit'
                        @click='handleUpdate(scope.row)'
                    >修改
                    </el-button>
                    <el-button
                        v-if='scope.row.type === "UNIVERSAL"'
                        icon='el-icon-plus'
                        size='mini'
                        type='text'
                        style='color: #67C23A'
                        @click='handleUpdateCodeNumber(scope.row)'
                    >增量
                    </el-button>
                    <el-button
                        v-if='scope.row.type === "UNIQUE"'
                        icon='el-icon-plus'
                        size='mini'
                        style='color: #F56C6C'
                        type='text'
                        @click='handleUpdateCodeNumber(scope.row)'
                    >增码
                    </el-button>
                    <el-button
                        icon='el-icon-delete'
                        size='mini'
                        type='text'
                        @click='handleDelete(scope.row, false)'
                    >删除
                    </el-button>
                    <el-button
                        icon='el-icon-delete'
                        size='mini'
                        type='text'
                        @click='handleDelete(scope.row, true)'
                    >批次删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        
        <div class='pagination'>
            <el-pagination
                :current-page='queryParams.pageNum'
                :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                :page-size='queryParams.pageSize'
                :total='queryParams.total'
                background
                layout='sizes, prev, pager, next'
                @size-change='handleSizeChange'
                @current-change='handlePagination'>
            </el-pagination>
        </div>
        
        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :visible.sync='open' :title='title' width='40%' append-to-body @close='cancel'>
            <el-form label-width='150'>
                <el-form-item label='礼包名' prop='name'>
                    <el-input v-if='!updateStatus' size='mini' type='text'
                              placeholder='请输入礼包码名称(任意, 仅用于内部识别)' v-model='currentGiftCode.name'
                              autocomplete='off' />
                    <span v-else>{{ currentGiftCode.name }}</span>
                </el-form-item>
                <el-form-item v-if='updateStatus' label='礼包码' prop='code'>
                    <span style='color: #409EFF'
                          @click='copyContent(currentGiftCode.code)'>{{ currentGiftCode.code }}</span>
                </el-form-item>
                <el-form-item v-if='!updateStatus'
                              :label='currentGiftCode.type !== "UNIQUE" ? "可兑换次数" : "生成数量"' prop='number'>
                    <el-input
                        :placeholder='currentGiftCode.type !== "UNIQUE" ? "请输入该礼包码可被兑换的次数，-1 表示不限制" : "请输入要生成的礼包码数量，每个码仅限一人兑换"'
                        size='mini'
                              v-model='currentGiftCode.number' />
                </el-form-item>
                <el-form-item v-if='updateStatus && currentGiftCode.type === "UNIVERSAL"' label='当前余量'
                              prop='number'>
                    <el-input placeholder='请输入通兑码余量' size='mini' type='number'
                              v-model='currentGiftCode.number' />
                </el-form-item>
                <el-form-item label='类型' prop='type'>
                    <el-select :disabled='updateStatus' size='mini' clearable v-model='currentGiftCode.type' filterable
                               placeholder='请选择礼包码类型'>
                        <el-option
                            v-for='item in giftCodeTypeOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='渠道' prop='number'>
                    <el-input style='width: 250px' placeholder='选填 请输入礼包码所属渠道' size='mini' type='text'
                              v-model='currentGiftCode.channel' />
                </el-form-item>
                <el-form-item v-if='updateStatus' label='礼包创建批次号' prop='number'>
                    <el-tooltip class='item' effect='dark'
                                content='创建礼包码时, 系统自动生成。同一批创建的礼包码, 批次号相同。通过批次号可以查询同一时间创建的多个礼包码'
                                placement='top-start'>
                        <span>{{ currentGiftCode.categoryTag }}</span>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label='活动开始时间' prop='startTime'>
                    <el-date-picker
                        v-model='currentGiftCode.startTime'
                        type='datetime'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        placeholder='选择活动开始时间'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label='活动结束时间' prop='endTime'>
                    <el-date-picker
                        v-model='currentGiftCode.endTime'
                        type='datetime'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        placeholder='选择活动结束时间'>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label='礼包码内容' prop='giftContent'>
                    <el-switch
                        v-model='switchShowGiftContentStatus'
                        active-text='解析'
                        inactive-text='编辑'>
                    </el-switch>
                    <el-input v-if='!switchShowGiftContentStatus' size='mini' :autosize='{ minRows: 10, maxRows: 20}'
                              type='textarea' v-model='editGiftContent'
                              placeholder='请输入礼包内容配置, 需为有效JSON格式, 并包含至少一个键值对' />
                    <vue-json-pretty v-if='switchShowGiftContentStatus' :data='computeGiftContent(editGiftContent)' />
                </el-form-item>
                
                <el-form-item label='礼包码组' prop='groupName'>
                    <el-input size='mini'
                              placeholder='同一组中的礼包码属于同类活动，用户在成功兑换其中一个礼包后，无法再使用该组内的其他礼包码'
                              type='text'
                              v-model='currentGiftCode.groupName' />
                </el-form-item>
            </el-form>
            
            <el-collapse v-if='!updateStatus' v-model='giftGenRuleActiveName'>
                <el-collapse-item title='礼包码生成规则' name='1'>
                    <el-form style='margin-top: 1rem' label-width='150'>
                        <el-alert
                            :title="`如果设置礼包码前缀, 那么生成的礼包码都将以 ${currentGiftCode.codeGenRule.customPrefix} 开始。默认情况下, 系统会自动
                                生成礼包码, 你也可以自定义礼包码。如果礼包码类型为'唯一码', 必须保证礼包码的数量为1。`"
                            :closable='false'
                            type='success'>
                        </el-alert>
                        <el-form-item v-if='!currentGiftCode.codeGenRule.customCode' label='自定义礼包码前缀'
                                      prop='customPrefix'>
                            <el-input size='mini' type='text' v-model='currentGiftCode.codeGenRule.customPrefix' />
                        </el-form-item>
                        <el-form-item label='自定义礼包码' prop='customCode'>
                            <el-input size='mini' type='text' v-model='currentGiftCode.codeGenRule.customCode' />
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
            <el-collapse v-model='redemptionConditionActiveName'>
                <el-collapse-item title='兑换条件' name='1'>
                    <el-form style='margin-top: 1rem' label-width='150'>
                        <el-form-item label='是否需要登录' prop='requireAccount'>
                            <el-switch
                                v-model='currentGiftCode.condition.requireAccount'
                                active-text='需要'
                                inactive-text='不需要'>
                            </el-switch>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
            <el-collapse v-model='sendConfigActiveName'>
                <el-collapse-item title='礼包内容发放配置' name='1'>
                    <el-alert
                        v-if='currentGiftCode.sendConfig.sendType === "DIRECT"'
                        title="选择'直接'后, 当客户端调用兑换接口, 服务端在处理礼包码成功后, 会直接将礼包内容返回给客户端"
                        :closable='false'
                        type='success'>
                    </el-alert>
                    <el-alert
                        v-if='currentGiftCode.sendConfig.sendType === "EMAIL"'
                        title="选择'邮件'后, 当客户端调用兑换接口, 服务端在处理礼包码成功后, 会直接将礼包内容通过IM系统发送给用户, 必须接入账号和IM系统"
                        :closable='false'
                        type='success'>
                    </el-alert>
                    <el-alert
                        v-if='currentGiftCode.sendConfig.sendType === "CLOUD_STORAGE"'
                        title="选择'云存储'后, 当客户端调用兑换接口, 服务端在处理礼包码成功后, 会直接将礼包内容保存至云存储中。需要应用接入云存储, 并且指定保存至哪个Class。
服务端会将当前登录用户的userId作为objectId, 将礼包内容作为更新数据。用户兑换成功后, 客户端可以根据objectId=userId去配置的Class中查询"
                        :closable='false'
                        type='success'>
                    </el-alert>
                    <el-form style='margin-top: 1rem' label-width='150'>
                        <el-form-item label='类型' prop='type'>
                            <el-col :span='10'>
                                <el-select size='mini' clearable v-model='currentGiftCode.sendConfig.sendType'
                                           @change='handleSendTypeChange' filterable placeholder='请选择'>
                                    <el-option
                                        v-for='item in giftContentSendTypeOptions'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item v-if='currentGiftCode.sendConfig.sendType === "CLOUD_STORAGE"'
                                      label='选择存储应用和Class'>
                            <el-cascader
                                v-model='contentSendConfig.cloudStorage.cascadeValue'
                                :options='contentSendConfig.cloudStorage.appOptions'
                                @change='handleSelectStorageApp'></el-cascader>
                        </el-form-item>
                        <el-form-item v-if='currentGiftCode.sendConfig.sendType === "EMAIL"' label='选择频道'>
                            <el-select size='mini' clearable v-model='contentSendConfig.email.channelId'
                                       filterable placeholder='请选择'>
                                <el-option
                                    v-for='item in contentSendConfig.email.channelList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if='currentGiftCode.sendConfig.sendType === "EMAIL"' label='选择模板(非必须)'>
                            <el-select size='mini' clearable v-model='contentSendConfig.email.templateName'
                                       filterable placeholder='请选择'>
                                <el-option
                                    v-for='item in contentSendConfig.email.templateList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.name'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if='currentGiftCode.sendConfig.sendType === "CLOUD_FUNCTION"'
                                      label='选择云函数'>
                            <el-select size='mini' clearable v-model='contentSendConfig.cloudFunction.functionName'
                                       filterable placeholder='请选择业务函数'>
                                <el-option
                                    v-for='item in contentSendConfig.cloudFunction.functionList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.name'>
                                    <span style='float: left'>{{ item.name }}</span>
                                    <span style='float: right; color: #8492a6; font-size: 13px'>{{ item.description
                                        }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
            <div slot='footer' class='dialog-footer'>
                <div>
                    <el-button type='primary' @click='submitForm'>{{ updateStatus ? '修 改' : '添 加' }}</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog title='礼包内容' :visible.sync='openGiftContentStatus' width='40%' append-to-body>
            <vue-json-pretty :data='currentGiftContent' />
        </el-dialog>
        
        <el-dialog :visible.sync='openUpdateGiftNumberStatus' width='40%' append-to-body>
            <el-form label-width='150'>
                <el-alert
                    v-if='currentGiftCode.type === "UNIVERSAL"'
                    :title='`当前通兑码余量为 ${currentGiftCode.originNumber}, 请输入需要额外增加多少个`'
                    :closable='false'
                    type='success'>
                </el-alert>
                <el-alert
                    v-if='currentGiftCode.type === "UNIQUE"'
                    :title='`请输入需要额外创建多少个唯一码`'
                    :closable='false'
                    type='success'>
                </el-alert>
                <el-form-item label='数量' prop='customPrefix'>
                    <el-input size='mini' type='number' v-model='currentGiftCode.number' />
                </el-form-item>
            </el-form>
            
            <div slot='footer' class='dialog-footer'>
                <div>
                    <el-button type='primary' @click='handleSubmitUpdateCodeNumber'>执行</el-button>
                    <el-button @click='openUpdateGiftNumberStatus = false'>取 消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { message } from '@/utils/message';
import { queryProjectInfoList } from '@api/ProjectInfo';
import { pageUtil } from '@/utils/pageUtil';
import { selectEmployeeList } from '@api/dashboard';
import CottonDynamicForm from '@/components/component/CottonDynamicForm.vue';
import TrackParameterDynamicForm from '@view/track/eventManage/TrackParameterDynamicForm.vue';
import IconIfyIcon from '@/components/component/icon/IconIfyIcon.vue';
import { giftCodeApi } from '@api/operation/giftCode/giftCodeApi';
import { deepCopy } from '@/utils/object';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import { copyContent } from '@/utils/string/cottonPlugin';
import { applicationCredentialApi } from '@api/Storage/applicaitonCredentialConfig';
import { storageSchemaApi } from '@api/Storage/storageSchema';
import { confirm } from '@/utils/confirm';
import { giftCodeGroupApi } from '@api/operation/giftCode/giftCodeGroup';
import { imChannelApi } from '@api/Im/ImChannelApi';
import { imMessageTemplateApi } from '@api/Im/ImMessageTemplateApi';
import { cloudFunctionApi } from '@/components/api/Other/cloudFunctionApi';

export default {
    name: 'GiftCode',
    components: { IconIfyIcon, TrackParameterDynamicForm, CottonDynamicForm, VueJsonPretty },
    props: {
        groupName: {
            type: String,
            required: false
        },
        groupId: {
            type: Number
        },
        projectAppId: {
            type: String
        },
        activePanel: {
            type: Boolean
        },
        adminUserList: {
            type: Array
        },
        projectInfoList: {
            type: Array
        }
    },
    emits: ['refreshGroupList'],
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            // 部门树选项
            projectTreeOptions: [],
            // 是否显示弹出层
            open: false,
            defaultProps: {
                label: 'label'
            },
            queryProjectName: undefined,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                
                projectAppId: undefined,
                groupName: undefined,
                type: undefined,
                channel: undefined,
                status: undefined,
                sendType: undefined,
                startTime: undefined,
                endTime: undefined,
                code: undefined,
                categoryTag: undefined,
                notJoinGroup: undefined
            },
            
            updateStatus: false,
            giftContentSendTypeOptions: [
                {
                    label: '直接',
                    value: 'DIRECT'
                },
                {
                    label: '邮件',
                    value: 'EMAIL'
                },
                {
                    label: '云存储',
                    value: 'CLOUD_STORAGE'
                },
                {
                    label: '云函数',
                    value: 'CLOUD_FUNCTION'
                }
            ],
            giftCodeTypeOptions: [
                {
                    label: '唯一码',
                    value: 'UNIQUE'
                },
                {
                    label: '通兑码',
                    value: 'UNIVERSAL'
                }
            ],
            giftStatusOptions: [
                {
                    label: '未启用',
                    value: false
                },
                {
                    label: '已启用',
                    value: true
                }
            ],
            giftCodeList: [],
            openGiftContentStatus: false,
            currentGiftContent: {},
            currentGiftCode: {
                condition: {},
                codeGenRule: {},
                sendConfig: {}
            },
            switchShowGiftContentStatus: false,
            codeGroupList: [],
            redemptionConditionActiveName: undefined,
            giftGenRuleActiveName: undefined,
            sendConfigActiveName: undefined,
            contentSendConfig: {
                cloudStorage: {
                    appOptions: [],
                    cascadeValue: [],
                    selectedAppId: undefined,
                    selectedClass: undefined,
                    fieldOptions: undefined
                },
                email: {
                    channelId: undefined,
                    templateName: undefined,
                    channelList: [],
                    templateList: []
                },
                cloudFunction: {
                    functionName: undefined,
                    functionList: []
                }
            },
            openUpdateGiftNumberStatus: false,
            editGiftContent: undefined
        };
    },
    watch: {
        // 根据名称筛选项目组
        queryProjectName(val) {
            this.$refs.tree.filter(val);
        },
        projectAppId() {
            this.getList();
        },
        activePanel() {
            this.getList();
        }
    },
    computed: {
        computeCreateUserAccount() {
            return (data, time) => {
                for (let i = 0; i < this.adminUserList.length; i++) {
                    if (data.createUserId === this.adminUserList[i].userId) {
                        return this.adminUserList[i].account;
                    }
                }
            };
        },
        computeUpdateUserAccount() {
            return (data, time) => {
                for (let i = 0; i < this.adminUserList.length; i++) {
                    if (data.updateUserId === this.adminUserList[i].userId) {
                        return this.adminUserList[i].account;
                    }
                }
            };
        },
        computeGiftContent() {
            return data => {
                let parse;
                try {
                    parse = JSON.parse(data);
                } catch (e) {
                    this.switchShowGiftContentStatus = false;
                    message.error('无效的JSON内容!');
                    throw e;
                }
                return parse;
            };
        }
    },
    created() {
        this.getList();
    },
    methods: {
        copyContent,
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            if (prop.indexOf('data.') === 0) {
                prop = prop.substring('data.'.length, prop.length);
            }
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.getList();
        },
        initData() {
            this.adminUserList = [];
            selectEmployeeList({ pageSize: 10000 }).then(result => {
                this.adminUserList = result.data;
            });
            // 获取所有的项目组
            queryProjectInfoList({ pageSize: 10000 }).then(result => {
                this.projectInfoList = result.data.result;
            });
        },
        getList() {
            if (!this.activePanel) {
                return;
            }
            this.giftCodeList = [];
            this.loading = true;
            
            if (this.queryParams.type === '') {
                this.queryParams.type = undefined;
            }
            if (this.queryParams.sendType === '') {
                this.queryParams.sendType = undefined;
            }
            this.queryParams.projectAppId = this.projectAppId;
            this.queryParams.notJoinGroup = this.groupName === undefined || this.groupName === '';
            this.queryParams.groupName = this.groupName;
            
            // 获取所有的事件
            giftCodeApi.query(this.queryParams).then(result => {
                if (result.code === 200) {
                    if (result.data) {
                        this.giftCodeList = result.data.result;
                    }
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize;
                }
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ]
            };
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '新增礼包码';
            this.editGiftContent = undefined;
            this.updateStatus = false;
            this.switchShowGiftContentStatus = false;
            this.currentGiftCode = {
                condition: {
                    requireAccount: true
                },
                codeGenRule: {},
                sendConfig: {},
                projectAppId: this.projectAppId,
                type: 'UNIVERSAL'
            };
            this.contentSendConfig = {
                cloudStorage: {
                    appOptions: [],
                    cascadeValue: [],
                    selectedAppId: undefined,
                    selectedClass: undefined,
                    fieldOptions: undefined
                },
                email: {
                    channelId: undefined,
                    templateName: undefined,
                    channelList: [],
                    templateList: []
                },
                cloudFunction: {
                    functionName: undefined,
                    functionList: []
                }
            };
        },
        handleRemove() {
            this.open = true;
            this.title = '移除项目组';
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.updateStatus = true;
            this.title = '修改礼包信息';
            this.switchShowGiftContentStatus = false;
            this.contentSendConfig = {
                cloudStorage: {
                    appOptions: [],
                    cascadeValue: [],
                    selectedAppId: undefined,
                    selectedClass: undefined,
                    fieldOptions: undefined
                },
                email: {
                    channelId: undefined,
                    templateName: undefined,
                    channelList: [],
                    templateList: []
                },
                cloudFunction: {
                    functionName: undefined,
                    functionList: []
                }
            };
            this.currentGiftCode = deepCopy(row);
            this.editGiftContent = JSON.stringify(this.currentGiftCode.giftContent, null, 4);
            if (this.currentGiftCode.sendConfig && this.currentGiftCode.sendConfig.sendType === 'CLOUD_STORAGE') {
                this.initCloudStorageOptions();
                if (this.currentGiftCode.sendConfig.config) {
                    this.contentSendConfig.cloudStorage.selectedAppId = this.currentGiftCode.sendConfig.config.appId;
                    this.contentSendConfig.cloudStorage.selectedClass = this.currentGiftCode.sendConfig.config.className;
                    this.contentSendConfig.cloudStorage.cascadeValue = [this.currentGiftCode.sendConfig.config.appId, this.currentGiftCode.sendConfig.config.className];
                }
            }else if (this.currentGiftCode.sendConfig && this.currentGiftCode.sendConfig.sendType === 'EMAIL') {
                this.initImOptions()
                if (this.currentGiftCode.sendConfig.config) {
                    this.contentSendConfig.email.channelId = this.currentGiftCode.sendConfig.config.channelId;
                    this.contentSendConfig.email.templateName = this.currentGiftCode.sendConfig.config.templateName;
                }
            } else if (this.currentGiftCode.sendConfig && this.currentGiftCode.sendConfig.sendType === 'CLOUD_FUNCTION') {
                this.initCloudFunctionOptions();
                if (this.currentGiftCode.sendConfig.config) {
                    this.contentSendConfig.cloudFunction.functionName = this.currentGiftCode.sendConfig.config.functionName;
                }
            }
        },
        /** 删除按钮操作 */
        handleDelete(row, multiDelete) {
            if (multiDelete) {
                giftCodeApi.queryCount({
                    projectAppId: row.projectAppId,
                    pageSize: 100000,
                    categoryTag: row.categoryTag
                }).then(result => {
                    if (result.code === 200) {
                        confirm.warning(`和 ${row.code} 同批次创建的礼包码有 ${result.data} 个, 确定要全部删除?`, undefined, () => {
                            giftCodeApi.deleteData({ id: row.id, deleteMulti: true }).then(result => {
                                if (result.code === 200) {
                                    this.getList();
                                    message.success(result.message);
                                }
                            });
                        });
                    }
                });
            } else {
                confirm.warning(`确定删除礼包码 ${row.code} ?`, undefined, () => {
                    giftCodeApi.deleteData({ id: row.id, deleteMulti: false }).then(result => {
                        if (result.code === 200) {
                            this.getList();
                            message.success(result.message);
                        }
                    });
                });
            }
        },
        /** 提交按钮 */
        submitForm: function() {
            try {
                this.currentGiftCode.giftContent = JSON.parse(this.editGiftContent);
            } catch (e) {
                message.error('礼包内容无效');
                return;
            }
            if (!this.currentGiftCode.projectAppId) {
                message.error('请选择项目!');
                return;
            }
            
            if (!this.currentGiftCode.type) {
                message.error('请选择礼包类型!');
                return;
            }
            if (!this.currentGiftCode.sendConfig.sendType || this.currentGiftCode.sendConfig.sendType === '') {
                this.currentGiftCode.sendConfig.sendType = undefined;
                this.currentGiftCode.sendConfig.config = undefined;
            }
            this.currentGiftCode.giftGroupName = this.currentGiftCode.groupName;
            if (this.currentGiftCode.sendConfig.sendType === 'EMAIL') {
                let config = {}
                config.channelId = this.contentSendConfig.email.channelId
                config.templateName = this.contentSendConfig.email.templateName
                this.currentGiftCode.sendConfig.config = config;
            } else if (this.currentGiftCode.sendConfig.sendType === 'CLOUD_STORAGE') {
                let config = {};
                config.appId = this.contentSendConfig.cloudStorage.selectedAppId;
                config.className = this.contentSendConfig.cloudStorage.selectedClass;
                this.currentGiftCode.sendConfig.config = config;
            } else if (this.currentGiftCode.sendConfig.sendType === 'CLOUD_FUNCTION') {
                let config = {};
                config.functionName = this.contentSendConfig.cloudFunction.functionName;
                this.currentGiftCode.sendConfig.config = config;
            }
            
            if (this.updateStatus) {
                // 修改操作
                this.doGiftCodeUpdate(this.currentGiftCode, null, () => {
                    this.open = false;
                    this.refreshGroupList();
                    this.getList();
                });
            } else {
                // 全部都是新增
                giftCodeApi.insert(this.currentGiftCode).then(result => {
                    if (result.code === 200) {
                        message.success(result.message);
                        this.refreshGroupList();
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        handleUpdateGiftCode(data) {
            this.doGiftCodeUpdate(data, () => {
                data.status = !data.status;
            }, () => this.getList());
        },
        addEmptyDynamicForm() {
            this.openTrackParameter = true;
            this.updateTrackParameterStatus = false;
            this.insertTrackParameter = {};
        },
        handleViewGiftContent(row) {
            this.openGiftContentStatus = true;
            this.currentGiftContent = deepCopy(row.giftContent);
        },
        handleSendTypeChange(value) {
            console.log(value);
            if (value === 'CLOUD_STORAGE') {
                this.initCloudStorageOptions();
            } else if (value === 'EMAIL') {
                this.initImOptions()
            } else if (value === 'CLOUD_FUNCTION') {
                this.initCloudFunctionOptions();
            }
        },
        initCloudFunctionOptions() {
            this.contentSendConfig.cloudFunction.functionList = [];
            if (!this.projectAppId) return;
            cloudFunctionApi.queryCloudFunctionList({
                projectAppId: this.projectAppId,
                type: 'PROJECT',
                pageNum: 1,
                pageSize: 1000
            }).then(res => {
                if (res.code === 200 && res.data) {
                    this.contentSendConfig.cloudFunction.functionList = res.data.result || [];
                }
            });
        },
        initCloudStorageOptions() {
            this.contentSendConfig.cloudStorage.appOptions = [];
            applicationCredentialApi.queryList().then(result => {
                if (result.code === 200) {
                    let appList = result.data;
                    if (!appList) {
                        message.error('未找到有效的云存储应用!');
                        return;
                    }
                    
                    appList.forEach((t, index) => {
                        if (t.projectAppId === this.currentGiftCode.projectAppId) {
                            let option = {
                                label: t.chineseName,
                                value: t.appId,
                                children: []
                            };
                            storageSchemaApi.queryAllSchema(t.appId).then(result => {
                                if (result.code === 200) {
                                    let schemaList = result.data.results;
                                    schemaList.forEach((f, fIndex) => {
                                        option.children.push({
                                            label: f.objectId,
                                            value: f.objectId,
                                            fieldOption: f.fieldOption
                                        });
                                        
                                        if (fIndex === schemaList.length - 1) {
                                            this.contentSendConfig.cloudStorage.appOptions.push(option);
                                        }
                                    });
                                }
                            });
                        }
                        
                        if (index === appList.length - 1) {
                            setTimeout(() => {
                                if (this.contentSendConfig.cloudStorage.appOptions.length === 0) {
                                    message.error('该项目未绑定云存储应用, 请先创建云存储应用!');
                                }
                            }, 2000);
                        }
                    });
                }
            });
        },
        initImOptions() {
            this.contentSendConfig.email.templateList = []
            this.contentSendConfig.email.templateList = []
            let projectName = this.projectInfoList.filter(t => t.appId === this.projectAppId)[0].name
            imChannelApi.query({pageSize: 10000, type: 'SYSTEM'}, projectName).then(result => {
                if (result.code === 200) {
                    this.contentSendConfig.email.channelList = result.data.result
                }
            })
            imMessageTemplateApi.query({pageSize: 10000}, projectName).then(result => {
                if (result.code === 200) {
                    this.contentSendConfig.email.templateList = result.data.result
                }
            })
        },
        handleSelectStorageApp(arr) {
            this.contentSendConfig.cloudStorage.selectedAppId = arr[0];
            this.contentSendConfig.cloudStorage.selectedClass = arr[1];
            this.contentSendConfig.cloudStorage.appOptions.forEach(t => {
                if (t.value === arr[0]) {
                    t.children.forEach(f => {
                        if (f.value === arr[1]) {
                            this.contentSendConfig.cloudStorage.fieldOptions = f.fieldOption;
                        }
                    });
                }
            });
        },
        doGiftCodeUpdate(giftCode, cancelCallback, successCallback) {
            giftCodeApi.queryCount({
                projectAppId: giftCode.projectAppId,
                pageSize: 100000,
                categoryTag: giftCode.categoryTag
            }).then(result => {
                if (result.code === 200) {
                    confirm.warning(`该修改会导致同一批次创建的礼包码都被修改, 预计影响条数${result.data}, 是否继续?`, undefined, () => {
                        giftCode.giftGroupName = giftCode.groupName;
                        giftCodeApi.update(giftCode).then(result => {
                            if (result.code === 200) {
                                if (successCallback) {
                                    successCallback();
                                }
                                message.success(result.message);
                            }
                        });
                    }, () => {
                        if (cancelCallback) {
                            cancelCallback();
                        }
                    });
                }
            });
        },
        handleUpdateCodeNumber(giftCode) {
            this.currentGiftCode = deepCopy(giftCode);
            this.currentGiftCode.originNumber = this.currentGiftCode.number;
            this.currentGiftCode.number = 0;
            this.openUpdateGiftNumberStatus = true;
        },
        handleSubmitUpdateCodeNumber() {
            if (this.currentGiftCode.number <= 0) {
                message.error('数量不能小于等于0');
                return;
            }
            this.currentGiftCode.deltaCount = this.currentGiftCode.number;
            delete this.currentGiftCode.number;
            this.doGiftCodeUpdate(this.currentGiftCode, null, () => {
                this.getList();
                this.openUpdateGiftNumberStatus = false;
            });
        },
        refreshGroupList() {
            this.$emit('refreshGroupList');
        },
        handleDeleteGroup() {
            confirm.error(`此操作会将 ${this.groupName} 组下的所有礼包码移出, 但不会被删除, 是否继续操作?`, null, () => {
                giftCodeGroupApi.deleteData({ id: this.groupId }).then(result => {
                    if (result.code === 200) {
                        message.success(result.message);
                        this.refreshGroupList();
                    }
                });
            }, null);
        }
    }
};
</script>
